<template>
  <v-card
    style="margin:auto;margin-top:50px;height:620px;"
    max-width="1000"
  >
   <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
   <v-card-title style="background-color:#006699;color:white;font-size:16px;">Administrador - Painel de activação de licença de utilização</v-card-title>
    <v-card-text style="margin-top:30px;margin-left:150px;">
        <v-row>
            <v-col cols="12" md="2">
               <label style="font-size:16px;font-weight:bold;">Endereço Mac: </label>
            </v-col>
            <v-col cols="12" md="6">
               <label style="font-size:16px;">{{this.getMacAdress}}</label>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
               <label style="font-size:16px;font-weight:bold;">Insíra o código fornecido pelo empresa do software: </label>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="8">
               <v-text-field
                  label="Código de activação"
                  clearable
                  v-model="chave"
                  outlined
               ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
               <v-btn small fab :disabled="chave === ''" color="primary" @click="ObterDadosLicenca()"><v-icon>search</v-icon></v-btn>
            </v-col>
        </v-row>
        <v-row>
           <v-col md="8">
            <fieldset>
               <legend>Dados da licença:</legend>
               <v-row style="margin-left:30px;">
                  <v-col md="6"><label style="font-weight:bold;">Tipo de licença:</label></v-col>
                  <v-col md="6"><v-chip style="background-color:#006699;color:white;">{{(licenseObject !== null)?licenseObject.tipo:''}}</v-chip></v-col>
                  <v-col md="6"><label style="font-weight:bold;">Duração</label></v-col>
                  <v-col md="6"><v-chip style="background-color:#006699;color:white;">{{(licenseObject !== null)?licenseObject.duracao:''}}</v-chip></v-col>
                  <v-col md="6"><label style="font-weight:bold;">Data de expiração:</label></v-col>
                  <v-col md="6"><v-chip style="background-color:#006699;color:white;">{{(licenseObject !== null)?utilitarios.AdicionarDiasaDataActual(licenseObject.duracao):''}}</v-chip></v-col>
               </v-row>
           </fieldset>
           </v-col>
        </v-row>
        <small>* Para conseguir activar a sua licença de utilização, terá de estar conectado a internet.</small>
    </v-card-text>
    <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" :disabled="licenseObject === null" @click="ActivarLicensa()" style="color:white;">Activar licença</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
import Swal  from 'sweetalert2'
const ls = require('local-storage')
export default {
   
   data: () => ({
      overlay: false,
      chave:'',
      licenseObject: null,
      utilitarios:utilitarios
   }),

   created(){
       
   },
   computed: {

      getMacAdress(){
         return ls.get('macadress')
      }

   },
   methods: {

      async ObterDadosLicenca(){
         //this.licenseObject = null
         this.overlay = true
         try {
            let params = {
               chave:this.chave,
               sistema:'FAT-ESC',

            }
            let result =  await axios.post('/admin-obter-licenca',params).then()
            if(result.data.length >=1){
               let values = result.data[0]
               if(values.status_usado  === 0)
                  this.licenseObject = result.data[0]
               else // Licença encontrada mas já foi usada
                 {
                    this.licenseObject = null
                    Swal.fire({icon: 'warning',title: 'Essa chave já foi utilizada.'})
                    //Faz uma cópia dos dados da licença para o local

                 }
            }else{
               this.licenseObject = null
               Swal.fire({icon: 'warning',title: 'Chave não encontrada'})
            }
         } catch (error) {
             Swal.fire({icon: 'error',title: 'Ocorreu um erro ao tentar efectuar a operação.'})
         }
         finally{
            this.overlay = false
         }
      }, // Fim =========


      async EfectuarCopiaLicenca (params){
         return await axios.post('/copiar-dados-licenca-local',params).then()
      },


     async ActivarLicensa (){
         
         this.overlay = true
         let params = {
            licenceObje: this.licenseObject,
            macadress:this.getMacAdress,
            chave:this.licenseObject.chave,
            dataExpiracao:utilitarios.AdicionarDiasaDataActual(this.licenseObject.duracao),
            autor: ls.get('nomeUsuario'),
            empresa:ls.get('empresa'),
            empresa_id:ls.get('i_id')
         }

         try {
           let result = await axios.post('/admin-activar-licenca',params).then()
           if(result.data.affectedRows >= 1){
              await this.EfectuarCopiaLicenca(params).then()
              this.licenseObject = null
              this.chave = ''
              Swal.fire({icon: 'success',title: 'Licença activada com sucesso'})
           }else{
              Swal.fire({icon: 'error',title: 'Ocorreu um erro ao tentar efectuar a operação'})
           }
         } catch (error) {
            Swal.fire({icon: 'error',title: 'Ocorreu um erro ao tentar efectuar a operação'})
            this.overlay = false
         }finally{
            this.overlay = false
         }

         // Swal.fire({icon: 'success',title: 'Licença activada com sucesso'})
            
      }

   }

}
</script>